var React = require('react');

function BookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#265888","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.333","d":"M8 13.333H3.467c-.747 0-1.12 0-1.406-.145a1.333 1.333 0 0 1-.582-.583c-.146-.285-.146-.658-.146-1.405V4.8c0-.747 0-1.12.146-1.405.127-.251.331-.455.582-.583.286-.145.659-.145 1.406-.145h.266c1.494 0 2.24 0 2.811.29.502.256.91.664 1.165 1.166C8 4.693 8 5.44 8 6.933m0 6.4v-6.4m0 6.4h4.533c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.583.146-.285.146-.658.146-1.405V4.8c0-.747 0-1.12-.146-1.405a1.334 1.334 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145h-.266c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C8 4.693 8 5.44 8 6.933"}));
}

BookIcon.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = BookIcon;

BookIcon.default = BookIcon;
